<template>
  <div>
    <SiteHeader />
    <div class="page flex-col">
      <img
        class="image_1"
        referrerpolicy="no-referrer"
        src="../lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png"
      />
      <div class="section_1 flex-col">
        <div class="block_3 flex-col">
          <div class="group_3 flex-row">
            <div class="text-group_1 flex-col">
              <span class="text_13">人事名录</span>
              <span class="text_14">（文案占位非正式内容）新闻与传播研究所人事名录相关资料。</span>
            </div>
          </div>
          <div class="text-wrapper_2">
            <span class="text_15">
              <router-link to="/lanhu_shouye" style="color: inherit; text-decoration: none;">首页</router-link>
              &nbsp;&gt;&nbsp;
              <router-link to="/lanhu_lirensuolingdao" style="color: inherit; text-decoration: none;">人事名录</router-link>
              &nbsp;&gt;&nbsp;
            </span>
            <span class="text_16">历任所领导</span>
          </div>
          <div class="group_4 flex-col"></div>
          <div class="group_5 flex-row justify-between" :class="{ 'is-pdf-focused': isPdfFocused }">
            <div class="sidebar-slot">
              <SidebarAccordion
                :sections="sidebarSections"
                active-section-id="personnel-directory"
                active-item-id="former-directors"
              />
            </div>
            <div class="group_7 flex-col content-slot">
              <FormerDirectorsContent />
            </div>
          </div>
        </div>
      </div>
      <SiteFooter
        :notch-width="704"
        notch-left="calc((100vw - 1300px) / 2 + 445px)"
      />
    </div>
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/SiteFooter.vue';
import SidebarAccordion from '@/components/SidebarAccordion.vue';
import FormerDirectorsContent from '@/components/FormerDirectorsContent.vue';
import { createSidebarSections } from '@/config/secondarySidebar';

export default {
  name: 'LanhuLirensuolingdao',
  components: {
    SiteHeader,
    SiteFooter,
    SidebarAccordion,
    FormerDirectorsContent
  },
  data() {
    return {
      sidebarSections: createSidebarSections({
        activeSectionId: 'personnel-directory',
        activeItemId: 'former-directors'
      })
    };
  }
};
</script>
<style scoped lang="css" src="../lanhu_jigouyulishi/assets/index.css" />
<style scoped>
.sidebar-slot {
  width: 274px;
  flex: 0 0 274px;
}

.sidebar-slot :deep(.sidebar-accordion) {
  width: 100%;
}

.content-slot {
  flex: 1;
  min-width: 0;
}
</style>
